// extracted by mini-css-extract-plugin
export default {"container":"wallet-header_container__8ycIQ","title":"wallet-header_title__GUUwj","balance":"wallet-header_balance__2cUg+","value":"wallet-header_value__7VZ2Y"};